import {DateRange} from './date-range';
import {DateRangeType, RelativeDate, TimeUnit} from './types';
import {DATE_RANGE_TYPE_DISPLAY_NAMES, TIME_COMPARISON_OPTIONS} from './presets';
/*
 * This class is used to support the Time Comparison Picker.
 */
export class RelativeDateRange extends DateRange {
  public getDefaultWindow(): RelativeDate {
    return {
      unit: TimeUnit.Day,
      value: 7,
    };
  }

  public getDefaultType(): DateRangeType {
    return DateRangeType.StartsOn;
  }

  public getDateRangeTypeOptions(): DateRangeType[] {
    return [DateRangeType.StartsOn, DateRangeType.EndsOn, DateRangeType.RelativeAfter];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return [TimeUnit.Day, TimeUnit.Week, TimeUnit.Month, TimeUnit.Quarter, TimeUnit.Year];
  }

  // Time comparison picker only wants to show Starts On/Ends On but still has RelativeAfter type
  public getDateRangeTypeDisplayOptions(): string[] {
    return [DateRangeType.StartsOn, DateRangeType.EndsOn].map((type) => DATE_RANGE_TYPE_DISPLAY_NAMES[type]);
  }

  public canUseRolling(): boolean {
    return true;
  }

  public isRolling(): boolean {
    return this.from && DateRange.isRelativeDate(this.from);
  }

  public getCalendarFromDate(): string {
    return DateRange.convertBaseDateToCalendarDate(this.from);
  }

  // These aren't normal DateRange presets, they should NOT be defined in the normal `DateRange.presets` or `DateRange.getPresetOptions()` methods.
  public static getTimeComparisonPresetOptions(): any {
    return [
      {
        label: `Previous day`,
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_DAY,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Day,
            value: 1,
          },
        },
      },
      {
        label: `Previous week`,
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_WEEK,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Week,
            value: 1,
          },
        },
      },
      {
        label: `Previous month`,
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_MONTH,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Month,
            value: 1,
          },
        },
      },
      {
        label: `Previous quarter`,
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_QUARTER,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Quarter,
            value: 1,
          },
        },
      },
      {
        label: `Previous year`,
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_YEAR,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Year,
            value: 1,
          },
        },
      },
    ];
  }
}
